import {
  faBell,
  faClipboardCheck,
  faNotesMedical,
  faPrint
} from '@fortawesome/free-solid-svg-icons';

/**
 * What MapYourMeds does for agency staff, shown in the brand panel of the
 * sign-in and registration pages. Agency-side features only (roles 4–7):
 * these visitors are agency staff, not pharmacy users (roles 1–3).
 */
const PRODUCT_FEATURES = [
  {
    icon: faClipboardCheck,
    title: 'Medpass made simple',
    text: "See what's due and record each dose as you give it."
  },
  {
    icon: faPrint,
    title: 'Medsheets and reports',
    text: 'Medsheets, treatment sheets, and medpass reports, ready to print.'
  },
  {
    icon: faNotesMedical,
    title: 'Records in one place',
    text: 'Prescriptions, vitals, and medical records for each person you support.'
  },
  {
    icon: faBell,
    title: 'Orders and refill reminders',
    text: 'See order history and confirm weekly refills.'
  }
];

export default PRODUCT_FEATURES;
